class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);


class DiscountComponent extends HTMLElement {
  constructor() {
    super();

    this.couponField = this.querySelector("[js-coupon-field]");
    this.discountForm = this.closest("[js-mini-cart-form]");
    this.discountErrorEl = this.querySelector("[js-discount-error]");
    this.drawerFooter = document.querySelector("[js-drawer-footer]");
    this.removeDiscountBtns = this.querySelectorAll("[js-remove-discount]");
    this.cart = this.closest('mini-cart');

    this.discountForm.addEventListener('submit', this.applyDiscount.bind(this));

    this.removeDiscountBtns.forEach(btn => btn.addEventListener("click", this.removeDiscount.bind(this)));
  }

  #existingDiscounts() {
    const discountCodes = [];
    const discountPills = this.querySelectorAll('.cart-discount__pill');
    for (const pill of discountPills) {
      if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === 'string') {
        discountCodes.push(pill.dataset.discountCode);
      }
    }

    return discountCodes;
  }

  async applyDiscount(evt) {
    evt.preventDefault();
    
    if(this.couponField.value === "") return;
    const discountCodeValue = this.couponField.value;

    const existingDiscounts = this.#existingDiscounts();
    if (existingDiscounts.includes(discountCodeValue)) return;
    
    this.drawerFooter.classList.add("is-loading");

    const body = JSON.stringify({
      discount: [...existingDiscounts, discountCodeValue].join(','),
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    try {
      const response = await fetch(theme.routes.cart_update_url, { ...fetchConfig(), ...{ body } });

      const data = await response.json();
      if (
        data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        this.#handleDiscountError('discount_code');
        return;
      };

      this.cart.renderContents(data);
      this.couponField.value = '';
    }catch (error) {
      console.log(error)
    }
  }

  async removeDiscount({ currentTarget }) {
    const pill = currentTarget;
    const discountCode = pill.dataset.discountCode;
    if (!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    this.drawerFooter.classList.add("is-loading");

    existingDiscounts.splice(index, 1);

    try {
      const body = JSON.stringify({ 
        discount: existingDiscounts.join(','), 
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      const response = await fetch(theme.routes.cart_update_url, { ...fetchConfig(), ...{ body } });

      const data = await response.json();
      this.cart.renderContents(data);
      
    } catch (error) {
       console.log(error)
    } 
  };

  #handleDiscountError() {
    this.couponField.value = "";
    this.discountErrorEl.classList.remove("hidden");
    this.drawerFooter.classList.remove("is-loading");
    setTimeout(() => {
      this.discountErrorEl.classList.add("hidden");
    }, 3000)
  }
}

customElements.define('discount-component', DiscountComponent);